import React from "react"
import {getRandomColor} from "../RandomColor";
import {Line} from "react-chartjs-2";

const AverageReplies = ({dates, report}) => {
    const replies = report && report.averageRepliesPerTicket
    const averages = replies && Object.keys(replies).map(rep => {
        return(
            {
                label: rep,
                data: Object.values(replies[rep]),
                fill: false,
                backgroundColor: '#fff',
                borderColor: getRandomColor(),
                borderWidth: 2,
                hoverBackgroundColor: getRandomColor(),
                pointBackgroundColor: getRandomColor(),
                pointRadius: 5,
                pointHoverRadius: 5
            }
        )
    })

    const data = {
        labels: dates,
        datasets: averages
    }
    const options = {
        elements: {
            line: {
                tension: 0.1 // disables bezier curves
            }
        },
        scales: {
            yAxes: [
                {
                    type: 'linear',
                    position: 'left',
                    display: true,
                    gridLines: {display: true},
                    ticks: {
                        beginAtZero: true,
                        stepSize: 10,
                        userCallback: function(label, index, labels) {
                            // when the floored value is the same as the value we have a whole number
                            if (Math.floor(label) === label) {
                                return label;
                            }

                        },
                    }
                },
                {
                    type: 'linear',
                    position: 'left',
                    display: false,
                    gridLines: {display: false},
                    ticks: {
                        precision: 0
                    }
                },
                {
                    type: 'linear',
                    position: 'left',
                    display: false,
                    gridLines: {display: false},
                },
            ],
            xAxes: [
                {
                    gridLines: {
                        display: false,
                    },
                }
            ],
        },
        legend: {
            position: "bottom",
            align: "center",
            labels: {
                padding: 25,
                usePointStyle: true,
                pointStyle: 'circle',
                boxWidth: 8,
                fontColor: '#25313C',
                fontSize: 12,
                fontStyle: "normal",
                fontWeight: "normal",
            }
        },
        tooltips: {
            mode: 'index',
            intersect: false,
            usePointStyle: true,
            backgroundColor: '#fff',
            displayColors: true,
            boxShadow: "0px 10.2133px 30.6398px -7.65994px rgba(15, 34, 67, 0.16), 0px 1.27666px 3.82997px rgba(15, 34, 67, 0.12), 0px 0px 1.27666px rgba(15, 34, 67, 0.16);",
            callbacks: {
                labelTextColor: function(tooltipItem, chart){
                    let dataset = chart.config.data.datasets[tooltipItem.datasetIndex];
                    return {
                        color : dataset.backgroundColor
                    }
                },
            }
        },
        hover: {
            mode: 'index',
            intersect: false
        }
    };
    return(
        <div className="report-chart-holder ml-0">
            <h3 className="report-overview-h3">Average Replies Per Ticket</h3>
            <Line
                data={data}
                options={options}
                width={100}
                height={50}
            />
        </div>
    )
}
export default AverageReplies
